import React, { useEffect } from 'react';
import {
    Redirect,
    Route,
    Switch,
    useHistory,
    useParams,
} from 'react-router-dom';

import { fetchCapabilitiesForExtension } from 'flow/actions/app-actions';
import { getBlockLists } from 'flow/actions/call-routing-actions';
import { fetchWidgetChannels } from 'flow/actions/channels-actions';
import { fetchLoggedInCustomer } from 'flow/actions/customers-actions';
import {
    fetchExtension,
    getCalendar,
    getPushtypes,
} from 'flow/actions/extension-actions';
import {
    fetchIntegrationAccessDomains,
    fetchIntegrationAccessTokens,
} from 'flow/actions/integration-access-actions';
import { fetchExtensionLicenseDescriptions } from 'flow/actions/license-actions';
import {
    fetchMainNumbers,
    fetchProfiles,
    fetchReferalSounds,
    listSMSSenderNameOptions,
} from 'flow/actions/profile-actions';
import { fetchSocialIntegrationSettings } from 'flow/actions/social-integration-actions';
import { fetchUserSounds } from 'flow/actions/sounds-actions';
import { fetchVoicemailSettings } from 'flow/actions/voicemail-actions';
import { fetchWallboards } from 'flow/actions/wallboard-actions';
import DashboardCreateWrapper from 'flow/components/dashboard/DashboardCreateWrapper';
import DashboardTemplates from 'flow/components/dashboard/DashboardTemplates';
import AudioInOut from 'flow/components/Setting/AudioInOut';
import Authentication from 'flow/components/Setting/Authentication';
import CallerId from 'flow/components/Setting/CallerId';
import CallerIdTypes from 'flow/components/Setting/CallerIdTypes';
import CallRecordingAndMonitoring from 'flow/pages/settings/call-recording/CallRecordingAndMonitoring';
import CallRecordingAndMonitoringSettings from 'flow/pages/settings/call-recording/CallRecordingAndMonitoringSettings';
import OpenOnAnswer from 'flow/components/Setting/CtiSettings/CtiSettingOpenOnAnswer';
import OpenOnCall from 'flow/components/Setting/CtiSettings/CtiSettingOpenOnCall';
import CtiSettings from 'flow/components/Setting/CtiSettings/CtiSettings';
import ShowOnLoad from 'flow/components/Setting/CtiSettings/CtiSettingShowOnLoad';
import Dashboards from 'flow/components/Setting/Dashboards';
import ManageTokens from 'flow/pages/settings/account/ManageTokens';
import SettingsGeneral from 'flow/pages/settings/general/SettingsGeneral';
import IncomingCalls from 'flow/components/Setting/IncomingCalls/IncomingCalls';
import IncomingCallsProfile from 'flow/components/Setting/IncomingCalls/IncomingCallsProfile';
import IncomingCallsProfileSettingPage from 'flow/components/Setting/IncomingCalls/IncomingCallsProfileSettingPage';
import Microphone from 'flow/components/Setting/Microphone';
import Mobile from 'flow/components/Setting/Mobile';
import NotificationProfiles from 'flow/components/Setting/NotificationProfiles';
import Notifications from 'flow/components/Setting/Notifications';
import Profile from 'flow/components/Setting/Profile';
import ProfileIncomingCallsSettingType from 'flow/components/Setting/Profile/IncomingCalls/SettingType';
import ProfileAvailability from 'flow/components/Setting/Profile/ProfileAvailability';
import ProfileAvailabilityPriority from 'flow/components/Setting/Profile/ProfileAvailabilityPriority';
import ProfileCallerId from 'flow/components/Setting/Profile/ProfileCallerId';
import ProfileCallRecording from 'flow/pages/settings/profiles/ProfileCallRecording';
import ProfileCallRecordingSettingsType from 'flow/pages/settings/profiles/ProfileCallRecordingSettingsType';
import ProfileIncomingCalls from 'flow/components/Setting/Profile/ProfileIncomingCalls';
import ProfileName from 'flow/components/Setting/Profile/ProfileName';
import ProfileNotifications from 'flow/components/Setting/Profile/ProfileNotifications';
import ProfileOperatorNote from 'flow/components/Setting/Profile/ProfileOperatorNote';
import ProfileQueueAndChatLogin from 'flow/components/Setting/Profile/ProfileQueueAndChatLogin';
import Profiles from 'flow/components/Setting/Profiles';
import QueueAndChatLogin from 'flow/components/Setting/QueueAndChatLogin';
import SettingsChannelLoginProfile from 'flow/components/Setting/SettingsChannelLoginProfile';
import QueueAndChatLoginPerProfile from 'flow/components/Setting/SettingsQueueLoginProfile';
import SimcardDetails from 'flow/components/Setting/SimcardDetails';
import SingleSimcard from 'flow/components/Setting/SingleSimcard';
import SocialIntegrationSynchronisation from 'flow/components/Setting/SocialIntegrationSynchronisation';
import Softphone from 'flow/components/Setting/Softphone';
import SoftphoneOutgoingCalls from 'flow/components/Setting/Softphone/SoftphoneOutgoingCalls';
import SoftphoneIncomingCalls from 'flow/components/Setting/Softphone/SoftphoneIncomingCalls';
import Speaker from 'flow/components/Setting/Speaker';
import AdditionalOutputDevice from 'flow/components/Setting/TelephonyAndAudio/AdditionalOutputDevice';
import AdvancedTelephony from 'flow/components/Setting/TelephonyAndAudio/AdvancedTelephony';
import CallReturnOnBlindTransfer from 'flow/components/Setting/TelephonyAndAudio/CallReturnOnBlindTransfer';
import CallRouting from 'flow/components/Setting/TelephonyAndAudio/CallRouting';
import CallRoutingTypes from 'flow/components/Setting/TelephonyAndAudio/CallRoutingTypes';
import CallWidgets from 'flow/components/Setting/TelephonyAndAudio/CallWidgets';
import CallWidgetTriggerType from 'flow/components/Setting/TelephonyAndAudio/CallWidgetTriggerType';
import EditCallRouting from 'flow/components/Setting/TelephonyAndAudio/EditCallRouting';
import EditCallRoutingAction from 'flow/components/Setting/TelephonyAndAudio/EditCallRoutingAction';
import EditCallRoutingDuring from 'flow/components/Setting/TelephonyAndAudio/EditCallRoutingDuring';
import EditCallRoutingException from 'flow/components/Setting/TelephonyAndAudio/EditCallRoutingException';
import EditCallRoutingExceptionAdd from 'flow/components/Setting/TelephonyAndAudio/EditCallRoutingExceptionAdd';
import CreateCallwidget from 'flow/components/Setting/TelephonyAndAudio/EditCallWidget';
import Ringtone from 'flow/components/Setting/TelephonyAndAudio/RingtoneAndVolume';
import SelectRingtone from 'flow/components/Setting/TelephonyAndAudio/SelectRingtone';
import Voicemail from 'flow/components/Setting/Voicemail';
import WorkHours from 'flow/components/Setting/WorkHours';
import ProfileSettingsDefaultDuration from 'flow/components/settings/ProfileSettingsDefaultDuration';
import SettingsSMSProfileChooser from 'flow/components/settings/SettingsSmsProfileChooser';
import SettingsContactEdit from 'flow/components/ui-components/SettingsContactEdit';
import SettingsGeneralLocale from 'flow/pages/settings/general/SettingsGeneralLocale';
import SettingsGeneralReportLogs from 'flow/pages/settings/general/SettingsGeneralReportLogs';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import ChangeEmail from 'flow/pages/settings/account/ChangeEmail';
import Email from 'flow/pages/settings/account/Email';
import Account from 'flow/pages/settings/account/SettingsAccount';
import SettingsTranscriptions from 'flow/pages/settings/transcriptions/SettingsTranscriptions';
import SettingsTranscriptionsDigest from 'flow/pages/settings/transcriptions/digest/SettingsTranscriptionsDigest';
import SettingsTranscriptionsQuota from 'flow/pages/settings/transcriptions/usage/SettingsTranscriptionsQuota';
import SettingsAccountLicense from 'flow/pages/settings/account/SettingsAccountLicense';
import CallMethod from 'flow/route-components/CallMethod';
import SettingsCalleridSMSEdit from 'flow/route-components/SettingsCalleridSmsEdit';
import SettingsMobileEsim from 'flow/route-components/SettingsMobileEsim';
import SettingsMobileRoamingData from 'flow/route-components/SettingsMobileRoamingData';
import SettingsProfileChooser from 'flow/route-components/SettingsProfileChooser';
import SettingsReleaseNotes from 'flow/pages/settings/general/SettingsReleaseNotes';
import SettingsUsageExtraData from 'flow/route-components/SettingsUsageExtraData';
import SettingsVoicemailAlternatives from 'flow/route-components/SettingsVoicemailAlternatives';
import SettingsVoicemailBusy from 'flow/route-components/SettingsVoicemailBusy';
import SettingsVoicemailLogin from 'flow/route-components/SettingsVoicemailLogin';
import SettingsVoicemailNotify from 'flow/route-components/SettingsVoicemailNotify';
import SettingsVoicemailRedialType from 'flow/route-components/SettingsVoicemailRedialType';
import SettingsVoicemailSound from 'flow/route-components/SettingsVoicemailSound';
import SettingsVoicemailUnavailable from 'flow/route-components/SettingsVoicemailUnavailable';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { isBundleCustomer } from 'flow/utils/bundle-utils';
import SettingsKeyboardShortcut from 'flow/pages/settings/general/SettingsKeyboardShortcut';
import { generatePath } from 'flow/utils/router-utils';
import { PrivateSettingsRoute } from './PrivateRoute';
import CallRecordingPerProfileSettings from 'flow/pages/settings/call-recording/CallRecordingPerProfileSettings';
import MonitoringSettings from 'flow/pages/settings/call-recording/MonitoringSettings';

const SettingsRoutes = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const isAdmin = useAppSelector(selectIsAdmin);
    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);
    const canEditExtension = extensionKey === ownExtensionKey || isAdmin;

    useEffect(() => {
        dispatch(fetchExtensionLicenseDescriptions());
        dispatch(fetchSocialIntegrationSettings());
        dispatch(fetchUserSounds());
        dispatch(fetchWallboards());
        dispatch(getBlockLists());
        dispatch(fetchIntegrationAccessDomains());
        dispatch(fetchWidgetChannels('apps'));

        if (extensionKey && canEditExtension) {
            dispatch(fetchLoggedInCustomer(extensionKey));
            dispatch(fetchVoicemailSettings(extensionKey));
            dispatch(getPushtypes(extensionKey));
            dispatch(fetchProfiles(extensionKey));
            dispatch(listSMSSenderNameOptions(extensionKey));
            dispatch(fetchExtension(extensionKey, 'settings'));
            dispatch(getCalendar(extensionKey));
            dispatch(fetchReferalSounds(extensionKey));
            dispatch(fetchMainNumbers(extensionKey));
            dispatch(fetchIntegrationAccessTokens(extensionKey));
            dispatch(fetchCapabilitiesForExtension(extensionKey));
        }
    }, [extensionKey]);

    if (!canEditExtension) {
        history.push(
            generatePath(routes['settings'], {
                extensionKey: ownExtensionKey,
            }),
        );
    }

    return (
        <Switch>
            <Redirect
                path="/settings/:extensionKey/notifcations/mobile"
                exact={true}
                to={`${generatePath(routes['settings.notifications'], { extensionKey })}?type=mobile`}
            />
            <Redirect
                path="/settings/:extensionKey/incoming"
                exact={true}
                to={generatePath(routes['settings.incoming-calls'], {
                    extensionKey,
                })}
            />
            <Redirect
                path="/settings/:extensionKey/calls/recording"
                exact={true}
                to={generatePath(
                    routes['settings.call-recording-and-monitoring'],
                    {
                        extensionKey,
                    },
                )}
            />
            <Redirect
                path="/settings/:extensionKey/calendar"
                exact={true}
                to={generatePath(routes['settings.work-hours'], {
                    extensionKey,
                })}
            />

            {isBundleCustomer(extensionKey) ? (
                <Redirect
                    path={routes['settings.account.license']}
                    to={routes['settings.account']}
                />
            ) : (
                <Route
                    path={routes['settings.account.license']}
                    component={SettingsAccountLicense}
                />
            )}

            <Route
                path={routes['settings.account.contact']}
                component={SettingsContactEdit}
            />

            <Route
                path={routes['settings.account.username-password']}
                component={Authentication}
                exact={true}
            />

            <Route
                path={routes['settings.account.username-password.manageTokens']}
                component={ManageTokens}
                exact={true}
            />

            <Route
                path={routes['settings.account.username-password.email']}
                component={Email}
                exact={true}
            />

            <Route
                path={
                    routes['settings.account.username-password.email.register']
                }
                component={ChangeEmail}
                exact={true}
            />

            <Route
                path={routes['settings.transcriptions.quota']}
                component={SettingsTranscriptionsQuota}
                exact={true}
            />

            <Route
                path={routes['settings.transcriptions.call-summary']}
                component={SettingsTranscriptionsDigest}
                exact={true}
            />

            <Route
                path={routes['settings.transcriptions']}
                component={SettingsTranscriptions}
            />

            <Route
                path={routes['settings.account.socialintegration.integration']}
                component={SocialIntegrationSynchronisation}
                exact={true}
            />

            <Route path={routes['settings.account']} component={Account} />

            <Route
                path={routes['settings.general.keyboardShortcuts']}
                component={SettingsKeyboardShortcut}
            />

            <Route
                path={routes['settings.general.reportlogs']}
                component={SettingsGeneralReportLogs}
            />

            <Route
                path={routes['settings.general.localechange']}
                component={SettingsGeneralLocale}
            />

            <Route
                path={routes['settings.general.release']}
                component={SettingsReleaseNotes}
            />

            <Route
                path={routes['settings.general']}
                component={SettingsGeneral}
            />

            <Route
                path={routes['settings.softphone.outgoing-calls']}
                component={SoftphoneOutgoingCalls}
                exact={true}
            />
            <Route
                path={routes['settings.softphone.incoming-calls']}
                component={SoftphoneIncomingCalls}
                exact={true}
            />

            <Route
                path={routes['settings.softphone.callmethod']}
                component={CallMethod}
                exact={true}
            />

            <Route
                path={routes['settings.softphone.ringtone.select-ringtone']}
                component={SelectRingtone}
            />

            <Route
                path={routes['settings.softphone.ringtone.audio-output']}
                component={AdditionalOutputDevice}
            />

            <Route
                path={routes['settings.softphone.ringtone']}
                component={Ringtone}
            />

            <Route
                path={routes['settings.softphone.audio-in-out.audio-output']}
                component={Speaker}
            />

            <Route
                path={routes['settings.softphone.audio-in-out.microphone']}
                component={Microphone}
            />

            <Route
                path={routes['settings.softphone.audio-in-out']}
                component={AudioInOut}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.exception.add'
                    ]
                }
                component={EditCallRoutingExceptionAdd}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.exception'
                    ]
                }
                component={EditCallRoutingException}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.during'
                    ]
                }
                component={EditCallRoutingDuring}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.action'
                    ]
                }
                component={EditCallRoutingAction}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey'
                    ]
                }
                component={EditCallRouting}
            />

            <Route
                path={routes['settings.softphone.advanced.callrouting.type']}
                component={CallRoutingTypes}
            />

            <Route
                path={routes['settings.softphone.advanced.callrouting']}
                component={CallRouting}
            />

            <Route
                path={routes['settings.softphone.advanced.blind-transfer']}
                component={CallReturnOnBlindTransfer}
            />

            <Route
                path={routes['settings.softphone.advanced']}
                exact={true}
                component={AdvancedTelephony}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callwidgets.callwidgetKey.triggertype'
                    ]
                }
                component={CallWidgetTriggerType}
            />

            <Route
                path={
                    routes[
                        'settings.softphone.advanced.callwidgets.callwidgetKey'
                    ]
                }
                component={CreateCallwidget}
            />

            <Route
                path={routes['settings.softphone.advanced.callwidgets']}
                component={CallWidgets}
            />

            <Route path={routes['settings.softphone']} component={Softphone} />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile.extradata']}
                component={SettingsUsageExtraData}
            />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile.esim']}
                component={SettingsMobileEsim}
            />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile.simKey.roaming']}
                component={SettingsMobileRoamingData}
                exact={true}
            />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile.simKey.details']}
                component={SimcardDetails}
                exact={true}
            />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile.simKey']}
                component={SingleSimcard}
            />

            <PrivateSettingsRoute
                requirement="mobile"
                path={routes['settings.mobile']}
                component={Mobile}
            />

            <Route
                path={routes['settings.voicemail.busy']}
                component={SettingsVoicemailBusy}
            />

            <Route
                path={routes['settings.voicemail.unavailable']}
                component={SettingsVoicemailUnavailable}
            />

            <Route
                path={routes['settings.voicemail.sound']}
                component={SettingsVoicemailSound}
            />

            <Route
                path={routes['settings.voicemail.login']}
                component={SettingsVoicemailLogin}
            />

            <Route
                path={routes['settings.voicemail.notify']}
                component={SettingsVoicemailNotify}
            />

            <Route
                path={routes['settings.voicemail.alternatives.redialtype']}
                component={SettingsVoicemailRedialType}
            />

            <Route
                path={routes['settings.voicemail.alternatives']}
                component={SettingsVoicemailAlternatives}
            />

            <Route path={routes['settings.voicemail']} component={Voicemail} />

            <PrivateSettingsRoute
                requirement="dashboard"
                path={routes['settings.dashboards.create']}
                component={DashboardCreateWrapper}
            />

            <PrivateSettingsRoute
                requirement="dashboard"
                path={routes['settings.dashboards.create.templates-picker']}
                component={DashboardTemplates}
            />

            <PrivateSettingsRoute
                requirement="dashboard"
                path={routes['settings.dashboards.edit']}
                component={DashboardCreateWrapper}
            />

            <PrivateSettingsRoute
                requirement="dashboard"
                path={routes['settings.dashboards']}
                component={Dashboards}
            />

            <PrivateSettingsRoute
                requirement="cti"
                path={routes['settings.cti-settings.showonload']}
                component={ShowOnLoad}
            />

            <PrivateSettingsRoute
                requirement="cti"
                path={routes['settings.cti-settings.openoncall']}
                component={OpenOnCall}
            />

            <PrivateSettingsRoute
                requirement="cti"
                path={routes['settings.cti-settings.openonanswer']}
                component={OpenOnAnswer}
            />

            <PrivateSettingsRoute
                requirement="cti"
                path={routes['settings.cti-settings']}
                component={CtiSettings}
            />

            <Route
                path={routes['settings.notifications.device.pushType']}
                component={NotificationProfiles}
            />

            <Route
                path={routes['settings.notifications']}
                component={Notifications}
            />

            <Route
                path={routes['settings.callerid.edit.sms']}
                component={SettingsCalleridSMSEdit}
            />

            <Route
                path={routes['settings.callerid.edit.numberType']}
                component={CallerIdTypes}
            />

            <Route
                path={routes['settings.callerid.profile.sms.edit.profileKey']}
                component={SettingsCalleridSMSEdit}
            />

            <Route
                path={routes['settings.callerid.profile.sms']}
                component={SettingsSMSProfileChooser}
            />

            <Route
                path={
                    routes[
                        'settings.callerid.profile.numberType.edit.profileKey'
                    ]
                }
                component={CallerIdTypes}
            />

            <Route
                path={routes['settings.callerid.profile.numberType']}
                component={SettingsProfileChooser}
            />

            <Route path={routes['settings.callerid']} component={CallerId} />

            <Route
                path={routes['settings.incoming-calls.profileKey.settingType']}
                component={IncomingCallsProfileSettingPage}
            />

            <Route
                path={routes['settings.incoming-calls.profileKey']}
                component={IncomingCallsProfile}
            />

            <Route
                path={routes['settings.incoming-calls']}
                component={IncomingCalls}
            />

            <Route
                path={
                    routes[
                        'settings.call-recording-and-monitoring.settings.profileKey'
                    ]
                }
                component={CallRecordingPerProfileSettings}
            />

            <Route
                path={
                    routes['settings.call-recording-and-monitoring.monitoring']
                }
                component={MonitoringSettings}
            />

            <Route
                path={routes['settings.call-recording-and-monitoring.settings']}
                component={CallRecordingAndMonitoringSettings}
            />

            <Route
                path={routes['settings.call-recording-and-monitoring']}
                component={CallRecordingAndMonitoring}
            />

            <Route
                path={routes['settings.queue-and-chat-login.channelKey']}
                component={SettingsChannelLoginProfile}
            />

            <Route
                path={routes['settings.queue-and-chat-login.queueKey']}
                component={QueueAndChatLoginPerProfile}
            />

            <Route
                path={routes['settings.queue-and-chat-login']}
                component={QueueAndChatLogin}
            />

            <Route
                path={
                    routes['settings.profiles.profileKey.availability.priority']
                }
                component={ProfileAvailabilityPriority}
            />

            <Route
                path={routes['settings.profiles.profileKey.availability']}
                component={ProfileAvailability}
            />

            <Route
                path={
                    routes[
                        'settings.profiles.profileKey.call-recording-and-monitoring.settingsType'
                    ]
                }
                component={ProfileCallRecordingSettingsType}
            />

            <Route
                path={
                    routes[
                        'settings.profiles.profileKey.call-recording-and-monitoring'
                    ]
                }
                component={ProfileCallRecording}
            />

            <Route
                path={routes['settings.profiles.profileKey.callerId']}
                component={ProfileCallerId}
            />

            <Route
                path={
                    routes[
                        'settings.profiles.profileKey.incoming-calls.settingType'
                    ]
                }
                component={ProfileIncomingCallsSettingType}
            />

            <Route
                path={routes['settings.profiles.profileKey.incoming-calls']}
                component={ProfileIncomingCalls}
            />

            <Route
                path={routes['settings.profiles.profileKey.name']}
                component={ProfileName}
            />

            <Route
                path={routes['settings.profiles.profileKey.note']}
                component={ProfileOperatorNote}
            />

            <Route
                path={routes['settings.profiles.profileKey.notifications']}
                component={ProfileNotifications}
            />

            <Route
                path={
                    routes['settings.profiles.profileKey.queue-and-chat-login']
                }
                component={ProfileQueueAndChatLogin}
            />

            <Route
                path={routes['settings.profiles.profileKey.duration']}
                component={ProfileSettingsDefaultDuration}
            />

            <Route
                path={routes['settings.profiles.profileKey']}
                component={Profile}
            />

            <Route path={routes['settings.profiles']} component={Profiles} />

            <Route path={routes['settings.work-hours']} component={WorkHours} />

            {!isSinglePaneMode && (
                <Redirect
                    path={routes['settings']}
                    exact={true}
                    to={generatePath(
                        extensionKey === ownExtensionKey
                            ? routes['settings.account']
                            : routes['settings.voicemail'],
                        {
                            extensionKey,
                        },
                    )}
                />
            )}

            <Route
                path={routes['settings']}
                component={
                    extensionKey === ownExtensionKey ? Account : Voicemail
                }
            />
        </Switch>
    );
};

export default SettingsRoutes;
